import * as types from 'common/constants';

const initialState = {
  list: {
    data: {
      data: [],
      count: 0
    },
    loading: false,
    error: null
  },
  detail: {
    data: {},
    loading: false,
    error: null
  }
};

interface Reducer {
  type: string;
  payload: any;
}

const ErpReducer = (state = initialState, { type, payload }: Reducer) => {
  switch (type) {
    /** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
     * Erp List cases
     */
    case types.ERP.REQUEST:
      return {
        ...state,
        list: {
          data: state.list.data,
          loading: true,
          error: null
        }
      };
    case types.ERP.SUCCESS:
      return {
        ...state,
        list: {
          data: payload,
          loading: false,
          error: null
        }
      };
    case types.ERP.FAILURE:
      return {
        ...state,
        list: {
          data: {
            list: [],
            totalPages: 0
          },
          loading: false,
          error: payload
        }
      };

    /** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
     * Erp Detail cases
     */
    case types.ERP_DETAIL.REQUEST:
      return {
        ...state,
        detail: { data: {}, loading: true, error: null }
      };
    case types.ERP_DETAIL.SUCCESS:
      return {
        ...state,
        detail: {
          data: payload,
          loading: false,
          error: null
        }
      };
    case types.ERP_DETAIL.FAILURE:
      return {
        ...state,
        detail: { data: {}, loading: false, error: payload }
      };

    default:
      return state;
  }
};

export default ErpReducer;
